import { createSelector } from "reselect"
import { get } from "lodash"
import moment from "moment"
import { getStartDateWithBoundaries, getDatesAdjusted as getDatesAdjustedHelper } from "helpers/dates"
import { createQueryStringSelector } from "selectors/queryString"
import { getPeriodOrStartAndEndDates } from "selectors/queryString/dates"

export const getModelCurrentDate = state => get(state, "global.data.factorTrendsDates.data.model.availability.currentDate")
export const getModelFactorsStartDate = state => get(state, "global.data.factorTrendsDates.data.model.availability.factorsStartDate")
export const getDate = createQueryStringSelector("date")

export const getEndDate = createSelector(
  [getModelCurrentDate, getPeriodOrStartAndEndDates, getModelFactorsStartDate],
  (latestDate, period, factorsStartDate) => {
    if (period.endDate) {
      if (period.endDate >= factorsStartDate && period.endDate < latestDate) return period.endDate
      return latestDate
    } else {
      return latestDate || moment().format("YYYY-MM-DD")
    }
  },
)

export const getStartDate = createSelector(
  [getEndDate, getPeriodOrStartAndEndDates, getModelFactorsStartDate, getModelCurrentDate],
  getStartDateWithBoundaries,
)

export const getSelectedDate = createSelector(
  [getDate, getModelCurrentDate, getModelFactorsStartDate, getEndDate],
  (selectedDate, latestDate, factorsStartDate, endDate) => {
    if (!selectedDate) return endDate
    if (selectedDate < factorsStartDate || selectedDate > latestDate) return latestDate
    return selectedDate
  },
)

export const getDatesAdjusted = createSelector(
  [getPeriodOrStartAndEndDates, getStartDate, getEndDate, getModelCurrentDate],
  getDatesAdjustedHelper,
)
